<template>
    <div class="d-sm-flex gap-6">
        <jet-input
            :model-value="modelValue"
            :description="description ?? trans('assets.details.curie_id.description')"
            :horizontal="false"
            :invalid-feedback="error"
            :label="label ?? trans('assets.details.curie_id.label')"
            :placeholder="placeholder ?? trans('assets.details.curie_id.placeholder')"
            :name="name"
            :required="required"
            style="flex-grow: 1"
            @update:model-value="(value) => emit('update:modelValue', value)"
        >
            <template #prepend>
                <icon icon="cil-qr-code" style="shape-rendering: crispEdges" />
            </template>
        </jet-input>
        <jet-button v-if="hasCameraSupport" class="mb-sm-0 my-6 border-primary" type="button" variant="secondary" @click="scan">
            {{ trans('assets.details.curie_id.button.scan') }}
        </jet-button>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import { useCurieIdScanner } from '@/composables/useCurieIdScanner.ts';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    modelValue: {
        type: String,
        default: '',
    },
    error: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: null,
    },
    name: {
        type: String,
        default: 'curieId',
    },
    required: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);

const hasCameraSupport = computed(() => !!navigator.mediaDevices);
const { openForScanningValue } = useCurieIdScanner();

async function scan() {
    const value = await openForScanningValue();
    if (value) {
        emit('update:modelValue', value);
    }
}
</script>
